import React from 'react';
import './FicoContent.css';
import FicoImg from '../../assets/images/Fico.png'; 

const FicoContent = () => {
  return (
    <section className="fico-page-content-section">
      <div className="container">
        {/* Top Intro Section */}
        <div className="fico-intro-grid">
          <div className="fico-intro-image-container">
            <img 
              src={FicoImg}
              alt="SAP FICO" 
              className="fico-intro-image"
            />
          </div>
          <div className="fico-intro-text">
            <h2 className="fico-intro-title">Why Choose NeuroverseAI for SAP FICO Solutions?</h2>
            <p>
              Looking for the Best SAP FICO Consultant Services USA Our consultants provide SAP FICO solutions to help businesses optimize their financial processes. We offer SAP FICO Data Security Solutions UAE, ensuring that your sensitive financial data remains protected.
            </p>
          </div>
        </div>

        {/* Features Grid Section */}
        <div className="fico-features-grid">
          <div className="fico-feature-card">
            <h3>SAP FICO Implementation Services: Streamline Your Financial Processes</h3>
            <p>
              At NeuroverseAI, we understand that implementing SAP FICO is crucial for businesses looking to streamline their financial processes. Our SAP FICO implementation services are tailored to meet the unique needs of your organization.
            </p>
          </div>
          <div className="fico-feature-card">
            <h3>SAP FICO Consulting Firm: Expert Guidance, Proven Results</h3>
            <p>
              NeuroverseAI is your trusted SAP FICO consulting firm, dedicated to providing expert advice and practical solutions that drive results. Whether you’re looking to optimize your existing SAP FICO system or implement new solutions, our team is equipped with the knowledge and skills to help your business thrive.
            </p>
          </div>
          <div className="fico-feature-card">
            <h3>SAP Financial Accounting Consultant: Unlock the Potential of Your Financial Data</h3>
            <p>
             As your SAP financial accounting consultant, we specialize in optimizing SAP FICO to ensure that your financial data is accurate, accessible, and actionable.
            </p>
          </div>
          <div className="fico-feature-card">
            <h3>SAP FICO Support Services: Ongoing Assistance When You Need It Most</h3>
            <p>
              At NeuroverseAI, we don’t just implement SAP FICO solutions; we also provide comprehensive SAP FICO support services to ensure your system operates smoothly long after deployment.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FicoContent;
